export default {

  configItems: {},
  pageContent: {},
  banners: [],

  bankCards: [],
  bankCard: {},

  tickets: [],
  ticket: {},

  dashboardItems: {},
  searchVendors: [],
  
  requirementProfile: {}
};
